import { baseUrl } from '@/api/types';

export function activitySourceUrl() {
  return `${baseUrl}/activities-source`;
}

export function productCategoriesSourceUrl() {
  return `${baseUrl}/product-categories-source`;
}

export function registerCountriesSourceUrl() {
  return '/register-countries';
}

export function translationUrl(lang = null) {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if (lang) {
    return `/translations?lang=${lang}`;
  } else if (params.lang) {
    return `/translations?lang=${params.lang}`;
  }

  return '/translations';
}
